import './dividerblock.less'

import {m} from '@codeurs/front'
import {FunctionComponent} from 'react'
import {style} from 'util/style'
import {Block} from 'views/blocks/blocks'

const styles = style('dividerblock')

export type DividerBlockType = {
	height: number
}

export const DividerBlock: FunctionComponent<DividerBlockType> = ({height}) => {
	return (
		<Block class={styles}>
			<div class={styles('divider')} style={{height: `${height}px`}} />
		</Block>
	)
}
